import AppModal from "@/components/AppModal";
import GuideBindMobile from "@/pages/guide/bindmobile/GuideBindMobile";
import {useTranslation} from "react-i18next";

export default function MobileDialog({
                                       open,
                                       onSuccess,
                                       onClose,
                                     }) {
  const {t} = useTranslation();

  const _onBindMobile = () => {
    if (onSuccess) onSuccess();
  }

  return (<>
    <AppModal open={open} onClose={onClose} title={t('bind_mobile')}>
      <GuideBindMobile onSuccess={_onBindMobile}/>
    </AppModal>
  </>);
}
